import React from 'react';
import { getUserData } from '../../services/API';

const SavingConfigModal = ({ onSaveToSchool, onSaveToDistrict, schoolName }) => {
  const districtName = getUserData().district.label;

  return (
    <div className='SaveConfigModal'>
      <div className='save-config-title'>Save just for <span className='highlight-opt-config'>{schoolName}</span> or save for all schools in the <span className='highlight-opt-config'>{districtName}</span> district?</div>
      <div className='save-config-content'>
        <div className='save-config-btn' onClick={onSaveToSchool}>Save to {schoolName}</div>
        <div className='save-config-btn' onClick={onSaveToDistrict}>Save to {districtName} district</div>
      </div>
    </div>
  );
};

export default SavingConfigModal;